import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutTags } from 'uitk-react-layout';
import styles from './uitk-layout-position.css';

var UitkLayoutPositionPointerEventsMap = [['none', 'pointerevents-none']];
var UitkLayoutPositionPointerEvents = new Map(UitkLayoutPositionPointerEventsMap);
var UitkLayoutPositionTypeMap = [
    ['relative', 'relative'],
    ['sticky', 'sticky'],
    ['absolute', 'absolute']
];
var UitkLayoutPositionTypes = new Map(UitkLayoutPositionTypeMap);

var getClassNameList = classNames.bind(styles);
var UitkLayoutPosition = function (props) {
    var children = props.children, className = props.className, cloneElement = props.cloneElement, display = props.display, pointerEvents = props.pointerEvents, position = props.position, tag = props.tag, type = props.type, attributes = __rest(props, ["children", "className", "cloneElement", "display", "pointerEvents", "position", "tag", "type"]);
    var childrenArray = React.Children.toArray(children);
    var firstChild = childrenArray[0];
    if (!firstChild || React.isValidElement(firstChild) === false) {
        return null;
    }
    var firstChildClassName = firstChild.props.className;
    var baseClass = 'uitk-layout-position';
    var wrapperClassNames = getClassNameList(baseClass, firstChildClassName && firstChildClassName, display && baseClass + "-display-" + display, pointerEvents && baseClass + "-" + UitkLayoutPositionPointerEvents.get(pointerEvents), position &&
        Object.entries(position)
            .map(function (_a) {
            var key = _a[0], val = _a[1];
            return baseClass + "-" + key + "-" + val;
        })
            .join(' '), type && baseClass + "-" + UitkLayoutPositionTypes.get(type), className);
    var decoratedChild = React.cloneElement(firstChild, __assign({ className: wrapperClassNames }, attributes));
    var Tag = ((tag && UitkLayoutTags.get(tag)) || UitkLayoutTags.get('div'));
    return cloneElement ? (decoratedChild) : (React.createElement(Tag, __assign({ className: wrapperClassNames }, attributes),
        ' ',
        children || null,
        ' '));
};
UitkLayoutPosition.displayName = 'UitkLayoutPosition';

export { UitkLayoutPosition };
